import React, { Component, Fragment } from 'react';
import Helmet from "react-helmet";
import { inject, observer } from 'mobx-react';
import {withRouter} from "react-router-dom";
import MovingStatistics from '../../components/movingStatistics/'; 
// import ResizeDetector from 'react-resize-detector';
import LineMenu from '../../components/liveMenu/';
import LineList from '../../components/line/';
import Basket from '../../components/basket/';
import Settings from '../../components/settingsLine/';
import Top from '../../components/scrollTopButton/';
import LoadingSpinner from '../../components/loadingSpinner/';
import SearchBox from '../../components/searchBox/';

@withRouter
@inject('accountStore', 'lineStore')
@observer
export default  class Line extends Component { 

	componentDidMount() {
		this.props.lineStore.init('line');
  }

  componentDidUpdate(){
  	this.props.lineStore.route.setUrl(this.props.match.params);
	}

	// onResize = () => {
	// 	this.props.lineStore.calcHeigth();
	// }
	
	render() {
			const {basketPosition} = this.props.accountStore.accountSettings;
			const {isLoading, basket, shortMenu} = this.props.lineStore;
			return(
				<div className="line line-view">
					<Helmet>
						<title>ИРМ - линия</title>
					</Helmet>
					{isLoading ? 
						<div> 
							<LoadingSpinner />
						</div> :
						<Fragment>
							<Settings />
							<SearchBox />
							<div className={`line-left-column ${shortMenu && basketPosition == 'right' ? 'line-left-column-short' : ''}`} id="line-left-column">
								{ basketPosition == 'left' ? 
									<div className="line-left-column-basket-cont">
										<Basket />
									</div> 
								: ''}
								{(basket.toogleBasket.showArrow || basketPosition == 'left') && !shortMenu && <MovingStatistics/>}
								<LineMenu/>
								<Top />
								{/*<ResizeDetector handleWidth handleHeight skipOnMount onResize={this.onResize} />*/}
							</div>
							{/*<div className={`line-central-column l-c-c-c-s ${ basketPosition == 'right' ? 'line-central-column-short-right' : ''} ${shortMenu && basketPosition == 'right' ? 'line-central-column-short-left' : ''}`} id="line-central-column" >*/}
								<LineList />
							{/*</div>*/}
							{ basketPosition == 'right' ? 
								<div className={`line-right-column line-right-column-border${basket.toogleBasket.showBasket ? ' open' : ''}`}>
									<Basket/> 
									{!basket.toogleBasket.showArrow && <MovingStatistics/>}
								</div>
							: ''}
						</Fragment>
					}
				</div> 
			)
	}
}
 


// WEBPACK FOOTER //
// ./src/routes/line/index.js